<template>
  <div>
     <headerimg></headerimg>
     <div class="cardinfo">
        <div class="cardtext">
          <div class="cardlist"  style="margin: 0;">
            <p class="test-1">Total Amount</p>
            <p class="test-2">KES {{List.amount}}</p>
          </div>
          <div class="cardlist">
            <p class="test-1">Send To</p>
<!--            <p class="test-2">Mpesa</p>-->
            <p class="test-2">{{dataSult.accountName}}</p>
          </div>
          <div class="cardlist">
            <p class="test-1">Card No</p>
            <div class="test-2">{{dataSult.accountNumber}}
            <img @click="copyAccountNumber(dataSult.accountNumber)" style="width: 0.84rem; height: 0.32rem;margin-left: 0.12rem;" src="../../assets/images/mpesa/copy.png" alt="">
            </div>
          </div>
        </div>

        <div class="code-conter">
          <div class="code-left">
            <div>
              <p class="text-1">qr code</p>
            </div>
            <div>
              <p class="text-2">SCAN OR TO SEND MONEY WITHDRAW OR LIPA M-P ESA</p>
            </div>
          </div>

          <div>
            <img style="width: 2.72rem;" :src="dataSult.paymentUrl" alt="">
          </div>
        </div>


     </div>

     <div class="btn">
       <button @click="paymentClike">{{btntext}}</button>
     </div>

     <emailtext></emailtext>
  </div>
</template>

<script>
	import {encryption} from "../../utils/requestUtils";

  export default {
		data() {
		  return {
		    List: {
		      mobile: '',
		      email: ''
		    },
		    Params: '',
		    request_flag: true,
			dataSult:'',
			btntext:'I have made this payment',
			timer:''
		  }
		},
		mounted() {
		  this.Params = this.$route.query
		  this.getParams()

		  // this.payment()
		  this.paymentxun()
		},
		beforeDestroy() {
			clearTimeout(this.timer)
		},
		methods: {
		  getParams() {
		    this.List = this.$route.query
		    console.log(this.$route)
		    console.log(this.List)
		  },
		  paymentClike(){
			  clearInterval(this.timer)
			  this.paymentxun()
		  },
		  paymentxun() {
        this.axios.post('/api/order/paymentStatus', {
          requestParam: encryption({
            merchantId: this.Params.merchantId,
            merchantOrderId: this.Params.merchantOrderId
          })
        }).then(res => {
				this.dataSult = res.data.data
		      if (res.data.data.status == 0) {
		        if (res.data.data.timeoutSeconds <= 0) {
		          this.$router.push({
		            path: '/mpesa/fail',
		            query: this.Params
		          })
		        } else {
		          this.timer = setTimeout(() => {
		            this.paymentxun()
		          }, 3000)
		        }

		        this.UserInfo = res.data.data
		      } else if (res.data.data.status == 1) {
		        this.$router.push({
		          path: '/mpesa/success',
		          query: this.Params
		        })
		      } else if (res.data.data.status == 2) {
		        this.$router.push({
		          path: '/mpesa/fail',
		          query: this.Params
		        })

		      }


		    })
		  },
		  payment() {
		    console.log(this.List)
		    if (!this.request_flag) {
		      return
		    }

		    // this.$toast('Payment Proceed')
		    this.btntext = "Loading...";
		    const that = this;
		    this.request_flag = false
		    this.flag = true // 加载中...
		    // const sign = localStorage.getItem('sign')
		    const timestamp = new Date().getTime()
		    const curURL = '/api/order/submitSecond'
		    const data = {
		      merchantId: that.List.merchantId,
		      merchantOrderId: that.List.merchantOrderId,
		      amount: that.Params.amount,
		      timestamp: timestamp,
		      sign: that.List.sign,
		      mobile: that.List.mobile,
		      email: that.List.email
		    }

		    this.axios.post(curURL, data).then(res => {
		      console.log(res.data.data.status)
		      if (res.data.data.status == 0) {
		        // 待支付
		        this.flag = false
		        this.$toast('Your money will be comfirmed in few minutes')
		      } else if (res.data.data.status == 1) {
		        // this.$toast('Payment success')
		        // this.$router.push({path: '/success', query: {'image': this.UserInfo.logoUrl}})
		        if (res.data.data.callbackUrl != '' && res.data.data.callbackUrl.startsWith('http')) {
		          window.location.href = res.data.data.callbackUrl
		        } else {
		          this.$router.push({
		            path: '/mpesa/success',
		            query: this.Params
		          })
		        }

		      } else if (res.data.data.status == 2) {
		        // this.$toast('Failure to pay')
		        this.$router.push({
		          path: '/mpesa/fail',
		          query: this.Params
		        })
		      }
		      this.request_flag = true
			  this.btntext='I have made this payment'
		    })
		  },
		  copyAccountNumber(msg){
			  navigator.clipboard.writeText(msg).then(()=>{
				  this.$toast('Successful replication')
			  }).catch(err=>{
				  this.$toast('Replication failure')
			  })
		  }
		},
	}
</script>

<style lang="scss">
  .cardinfo{
    width: 5.54rem;
    margin: 0 auto;
    background: #FFFFFF;
    border-radius: 0.32rem;
    margin-top: 0.5rem;
    padding: 0.5rem 0.5rem;
    .cardtext{
      border-bottom: 1px dashed #A8AFB6;
      padding-bottom: 0.5rem;
      .cardlist{
        display: flex;
        justify-content: space-between;
        margin-top: 0.48rem;
        .test-1{
          font-size: 0.32rem;
          font-family: PingFang-SC-Heavy, PingFang-SC;
          font-weight: 800;
          color: #191932;
        }
        .test-2{
          font-size: 0.32rem;
          font-family: PingFang-SC-Heavy, PingFang-SC;
          font-weight: 800;
          color: #00B935;
          display: flex;
          justify-content: center;
          align-items: center;

        }
      }
    }

    .code-conter{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 0.46rem;
      .code-left{
        width: 1.98rem;
        display: flex;
        flex-direction: column;
        text-align: left;
        .text-1{
          font-size: 0.32rem;
          font-family: PingFang-SC-Heavy, PingFang-SC;
          font-weight: 800;
          color: #191932;
        }
        .text-2{
          font-size: 0.2rem;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #282E34;
          margin-top: 0.24rem;
        }
      }
    }


  }
  .btn{
    button{
      border: none;
      width: 6.54rem;
      height: 1.08rem;
      background: linear-gradient(138deg, #8AFFA7 0%, #FEFD42 100%);
      border-radius: 0.16rem;
      font-size: 0.3rem;
      font-family: PingFang-SC-Heavy, PingFang-SC;
      font-weight: 800;
      color: #151515;
      margin-top: 0.32rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/mpesa/cardNumber.vue